import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

import commonApi from '../../common/common'
Vue.prototype.$commonApi = commonApi

import '../../common/common.min.css'

import vueClip from 'vue-clipboard2'
Vue.use(vueClip);

new Vue({
  render: h => h(App),
}).$mount('#app')
